
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Customer } from '../../models';
import { TransferChannel } from '../../models/AsyncDataItem';
import * as moment from 'moment';
import Enumerable from 'linq';
import { SignalTag } from '../../app/models/SignalTag';

/**
 * Store global data used across app
 */
@Injectable()
export class DataProvider {
  user: any = {};
  demoLogBook: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>(
    []
  );

  trendExplorerTags = new BehaviorSubject<{
    data: SignalTag[],
    loading: boolean
  }>({
    data: [],
    loading: true
  });

  constructor(
  ) { }

  clearData() {
    this.trendExplorerTags.next({
      data: [],
      loading: true
    });
    this.user = {};
  }

  buildMonthlyLogBookData(logs): {
    monthlyLogs: any,
    months: Array<string>
  } {
    let months = [];
    let dateStart = moment().subtract(1, 'year');
    let dateEnd = moment();
    while (
      dateEnd > dateStart ||
      dateStart.format('M') === dateEnd.format('M')
    ) {
      months.push(dateStart.format('MMM YYYY'));
      dateStart.add(1, 'month');
    }

    let monthlyData = {};
    for (let month of months) {
      monthlyData[month] = [];
      monthlyData[month].push(
        ...Enumerable.from(logs)
          .select(x => x)
          .where(x => moment(x['siteTime']).format('MMM YYYY') === month)
          .orderByDescending(x => x['siteTime'])
          .toArray()
      );
    }

    return {
      monthlyLogs: monthlyData,
      months: months
    };

  }

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts